// extracted by mini-css-extract-plugin
export default {"icon":"Upload_icon__4v9Ej"};